import template from './cameraIcon.html';

export const CameraIconModule = angular
    .module('app.components.imageManager.components.cameraIcon', [])
    .component('cameraIcon', {
        template
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/imageManager/components/cameraIcon.component.js